/* TAXXON 2026 - aparicion suave al hacer scroll.
   Si no hay IntersectionObserver, todo queda visible. */
(function () {
  function reveal() {
    var els = document.querySelectorAll('.txn-rv');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (x) {
        if (x.isIntersecting) { x.target.classList.add('in'); io.unobserve(x.target); }
      });
    }, { threshold: 0.1 });
    els.forEach(function (e) { io.observe(e); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reveal);
  } else {
    reveal();
  }
  document.addEventListener('shopify:section:load', reveal);
})();
